import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetTechSemantic } from '@/infrastructure/api-functions/interface/get-tech-semantic.interface';
import type { AISearchRepository } from '../../service/ai-search.repository.interface';

export const GetTechSemanticDTO = Symbol('GetTechSemanticDTO');

export interface GetTechSemanticDTO {
    fetch: AISearchRepository['getSemantic'];
}

@injectable()
export class GetTechSemanticDTOImpl implements GetTechSemanticDTO {
    constructor(
        @inject(GetTechSemantic)
        private readonly _getTechSemanticApi: GetTechSemantic,
    ){}

    async fetch(param: string[]) {
        const data = await this._getTechSemanticApi.getTechSemantic(param);
        return data;
    }
}